module.exports = __webpack_public_path__ + "media/images/lb/187-c72796b0f63182b6dab664876b4d51f1.svg";